import React from 'react';
import styles from './InventoryReconciliation.module.scss';
import DataTable from 'react-data-table-component';
import FilterInTable from '../../../../Manage/FilterInTable';

const data = [
    {
        id: 1,
        productId: '001',
        productName: 'Blue Colored Headphones',
        physicalCount: 500,
        recordedCount: 520,
        discrepancy: -20,
        valuePerUnit: '$50',
        discrepancyValue: '-$1000',
        discrepancyCause: 'Data Entry Error',
        action: 'Adjusted Records',
    },
    {
        id: 2,
        productId: '001',
        productName: 'Blue Colored Headphones',
        physicalCount: 500,
        recordedCount: 520,
        discrepancy: -20,
        valuePerUnit: '$50',
        discrepancyValue: '-$1000',
        discrepancyCause: 'Data Entry Error',
        action: 'Adjusted Records',
    },
    {
        id: 3,
        productId: '001',
        productName: 'Blue Colored Headphones',
        physicalCount: 500,
        recordedCount: 520,
        discrepancy: -20,
        valuePerUnit: '$50',
        discrepancyValue: '-$1000',
        discrepancyCause: 'Data Entry Error',
        action: 'Adjusted Records',
    },
    {
        id: 4,
        productId: '001',
        productName: 'Blue Colored Headphones',
        physicalCount: 500,
        recordedCount: 520,
        discrepancy: -20,
        valuePerUnit: '$50',
        discrepancyValue: '-$1000',
        discrepancyCause: 'Data Entry Error',
        action: 'Adjusted Records',
    },
    {
        id: 5,
        productId: '001',
        productName: 'Blue Colored Headphones',
        physicalCount: 500,
        recordedCount: 520,
        discrepancy: -20,
        valuePerUnit: '$50',
        discrepancyValue: '-$1000',
        discrepancyCause: 'Data Entry Error',
        action: 'Adjusted Records',
    },
];

const columns = [
    {
        name: 'Product ID',
        selector: (row) => row.productId,
        sortable: true,
        width: '160px',
    },
    {
        name: 'Product Name',
        selector: (row) => row.productName,
        sortable: true,
        width: '250px',
    },
    {
        name: 'Physical Count',
        selector: (row) => row.physicalCount,
        sortable: true,
        width: '200px',
    },
    {
        name: 'Recorded Count',
        selector: (row) => row.recordedCount,
        sortable: true,
        width: '200px',
    },
    {
        name: 'Discrepancy (Physical - Recorded)',
        selector: (row) => row.discrepancy,
        sortable: true,
        width: '340px',
    },
    {
        name: 'Value per Unit',
        selector: (row) => row.valuePerUnit,
        sortable: true,
        width: '180px',
    },
    {
        name: 'Discrepancy Value',
        selector: (row) => row.discrepancyValue,
        sortable: true,
        width: '220px',
    },
    {
        name: 'Cause of Discrepancy',
        selector: (row) => row.discrepancyCause,
        sortable: true,
        width: '250px',
    },
    {
        name: 'Corrective Action',
        selector: (row) => row.action,
        sortable: true,
        width: '220px',
    },
];

const customStyles = {
    table: {
        style: {
            borderLeft: '1px solid #D9D9D9',
            borderTop: '1px solid #D9D9D9',
        },
    },
    headRow: {
        style: {
            backgroundColor: '#FBBD34',
            color: '#FFFFFF',
            fontSize: '16px',
            fontWeight: '600',
            borderBottom: 'none',
        },
    },
    headCells: {
        style: {
            paddingLeft: "20px",
            paddingRight: "20px",
            borderRight: '1px solid #D9D9D9',
            div: {
                whiteSpace: "normal",
                overflow: "visible",
            },
        },
    },
    cells: {
        style: {
            fontSize: '15px',
            padding: '15px 20px',
            borderRight: '1px solid #D9D9D9',
            div: {
                whiteSpace: "normal !important",
                overflow: "visible !important",
            },
        },
    },
};

const InventoryReconciliation = () => {

    return (
        <div className={styles.mainContainer}>
            <h4 className={styles.sectionHeading}>Inventory Reconciliation Report</h4>

            <div className={styles.filterTableContainer}>

                <FilterInTable componentName={"Inventory Reconciliation Report"} />

                <div className={styles.table}>
                    <DataTable
                        columns={columns}
                        data={data}
                        pagination
                        highlightOnHover
                        customStyles={customStyles}
                    />
                </div>
            </div>
        </div>
    )
}

export default InventoryReconciliation;